export default import.meta.ROLLUP_FILE_URL_4j5D_HB$xBQpXpQwXSPDfg